// テーマ切替（ライト/ダーク）。未設定時はOS設定に追従し、
// 切替ボタンで選んだ値を localStorage に保存する。
const THEME_KEY = 'ttts-theme'

type Theme = 'light' | 'dark'

const SUN_SVG =
  '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>'

const MOON_SVG =
  '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>'

const media = window.matchMedia('(prefers-color-scheme: dark)')

function storedTheme(): Theme | null {
  const value = localStorage.getItem(THEME_KEY)
  return value === 'light' || value === 'dark' ? value : null
}

function currentTheme(): Theme {
  return storedTheme() ?? (media.matches ? 'dark' : 'light')
}

function apply(): void {
  const theme = currentTheme()
  document.documentElement.dataset.theme = theme

  const button = document.getElementById('theme-toggle')
  if (button) {
    button.innerHTML = theme === 'dark' ? SUN_SVG : MOON_SVG
    button.title = theme === 'dark' ? 'ライトモードに切り替え' : 'ダークモードに切り替え'
  }
}

export function initTheme(): void {
  apply()

  document.getElementById('theme-toggle')?.addEventListener('click', () => {
    const next: Theme = currentTheme() === 'dark' ? 'light' : 'dark'
    localStorage.setItem(THEME_KEY, next)
    apply()
  })

  // 手動選択していない間はOS設定の変更に追従する
  media.addEventListener('change', () => {
    if (!storedTheme()) apply()
  })
}
